<div class="text-center">
  <div class="p-3">
    <h4>{{question.text}}</h4>
  </div>
  <div id="question-answers-chart" style="min-height: 300px;"></div>
</div>
